export const DEFAULT_WIFI_SUPPORT_PHONE = '567-406-0378';


